<template>
<section id="company" class="company container sub">
    <div class="wrapper inner">
        <h2 class="left" data-aos="fade-up"><SvgTitle /><caption>COMPANY DATA</caption></h2>
        <div class="inner" data-aos="fade-up">
            <table class="table">
                <tbody>
                    <tr v-for="item in info" :key="item.title">
                        <td class="title" v-html="item.title"></td>
                        <td class="text" v-html="item.text"></td>
                    </tr>
                </tbody>
            </table>
            <div id="map" />
        </div>
    </div>
</section>
</template>

<script>
import SvgTitle from '@/assets/icon/h2/company.svg?inline'
export default {
  name: 'sectionCompany',
  components: {
      SvgTitle,
  },
  data(){
      return{
          info: [
              {
                  'title': '会社名',
                  'text': '株式会社クアードプロダクション'
              },
              {
                  'title': '住所',
                  'text': '<a href="https://goo.gl/maps/KTW9hJgzq8NAAHhY9" target="_blank">〒921-8815 石川県野々市市本町<br class="onlySp">2-1-21、1の1NONOICHI オフィス5</a>'
              },
              {
                  'title': '設立',
                  'text': '2017年6月19日'
              },
              {
                  'title': '資本金',
                  'text': '200万円'
              },
              {
                  'title': 'お問合せ',
                  'text': '<a href="mailto:info@quad-pro.com" target="_blank">info@quad-pro.com</a><br class="onlySp"><i class="hideSp">&nbsp/&nbsp</i><a href="tel:050-5375-6064">050-5375-6064</a>'
              },
          ],
      }
  },
  mounted(){
 
  }
}
</script>

<style lang="scss">
#company{
    padding-top: 0;
    .wrapper{
        @media #{$IE}{
            align-items: flex-start;
        }
        h2{
            @media #{$IE}{
                width: 170.45px;
            }
        }
        h2{
            margin-bottom: 20px;
            @media #{$maxM}{
                svg{
                    height: 10px;
                }
                margin-bottom: 10px;
            }
        }
        .inner{
            padding-bottom: 0;
            
            .table{
                width: 100%;
                -webkit-border-vertical-spacing: 1.2em;
                border-collapse: separate;
                margin-bottom: 54px;
                @media #{$maxM}{
                    margin-bottom: 42px;
                }
                    tr{
                        @media #{$maxM}{
                            line-height: 1.5em;
                            vertical-align: top;
                        }
                        .title{
                            display: table-cell;
                            width: 4.4rem;
                            padding-right: 30px;
                            text-align: justify;
                            text-align-last: justify;
                            color: #605e5e;
                            @media #{$maxM}{
                                padding-right: 4.26vw;
                            }
                        }
                        .text{
                            display: flex;
                            flex-flow: row wrap;
                            color: $black;
                            font-weight: 500;
                            a{
                                text-align: left;
                                display: block;
                                text-decoration: underline;
                                    &:hover{
                                        color: #605e5e;
                                    }
                            }
                            @media #{$maxM}{
                                line-height: 1.5em;
                            }
                        }
                    }
            }
        }
    }
    #map{
        width: 100%;
        height: 500px;
        background: #f7f7f7;
        @media #{$maxM}{
            height: 260px;
        }
    }
}
</style>
